module.exports = __webpack_public_path__ + "img/drag.916763b5.svg";